module.exports = __webpack_public_path__ + "img/electronic-topographic-map.cbd3252c.png";